import CompanyRepository from '@/shared/http/repositories/configuration/company'
import { mutationTypes as mutation } from './mutations'

const GET_COMPANY_BY_ID = 'getCompanyById'
const GET_COMPANY_BY_CODIGO = 'getCompanyByCodigo'

export const actionTypes = {
  GET_COMPANY_BY_ID,
  GET_COMPANY_BY_CODIGO
}

export const actions = {
  [GET_COMPANY_BY_ID] ({ commit }, payload) {
    return CompanyRepository.GetById(payload)
      .then(response => {
        sessionStorage.setItem('company', JSON.stringify(response.data.data))
        commit(mutation.SET_COMPANY, response.data.data)
      })
  },

  [GET_COMPANY_BY_CODIGO] ({ commit }, payload) {
    return CompanyRepository.GetByCodigo(payload)
      .then(response => {
        sessionStorage.setItem('company', JSON.stringify(response.data.data))
        commit(mutation.SET_COMPANY, response.data.data)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/module/company/actions.js